import { configureStore } from "@reduxjs/toolkit"
import { userReducer } from "./slice/userSlice"
import { appReducer } from "./slice/appSlice"
import { organizationReducer } from "./slice/organizationSlice"
import { workflowReducer } from "./slice/workflowSlice"
import { workflowRunHistoryReducer } from "./slice/workflowRunHistory"
import { applicationsReducer } from "./slice/applicationsSlice"
import { credentialReducer } from "./slice/credentialSlice"
import { billingReducer } from "./slice/billingSlice"
import { transformationReducer } from "./slice/transformationSlice"
import { adminDashboardReducer } from "./slice/adminDashboardSlice"
import { dashboardsReducer } from "./slice/dashboardsSlice"
import { chatSessionReducer } from "./slice/chatSessionSlice"
import { dashboardDomainRegistryReducer } from "./slice/dashboardDomainRegistrySlice"
import { dashboardPanelsReducer } from "./slice/dashboardPanelsSlice"
import { dashboardSyncReducer } from "./slice/dashboardSyncSlice"
import { dashboardCreationReducer } from "./slice/dashboardCreationSlice"
import { dashboardViewReducer } from "./slice/dashboardViewSlice"
import { dashboardEditChatReducer } from "./slice/dashboardEditChatSlice"

export const store = configureStore({
  reducer: {
    app: appReducer,
    application: applicationsReducer,
    credentials: credentialReducer,
    billing: billingReducer,
    dashboardDomainRegistry: dashboardDomainRegistryReducer,
    dashboards: dashboardsReducer,
    organization: organizationReducer,
    transformation: transformationReducer,
    user: userReducer,
    workflow: workflowReducer,
    workflowRunHistory: workflowRunHistoryReducer,
    adminDashboard: adminDashboardReducer,
    chatSession: chatSessionReducer,
    dashboardPanels: dashboardPanelsReducer,
    dashboardSync: dashboardSyncReducer,
    dashboardCreation: dashboardCreationReducer,
    dashboardView: dashboardViewReducer,
    dashboardEditChat: dashboardEditChatReducer,
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
